import EntityBaseApiService, { Mode } from '../__base/EntityBaseApiService';

export { Mode };

export interface IOptions {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  headers?: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  [k: string]: any;
}

export default class RestStandardModuleApiService extends EntityBaseApiService {
  isStandardSettingsEnabled = true;
  isHeadersEnabled;
  isLogEnabled;

  constructor(
    constructorParams,
    isStandardSettingsEnabled = true,
    isHeadersEnabled = true,
    isLogEnabled = false
  ) {
    super(constructorParams);
    this.isStandardSettingsEnabled = isStandardSettingsEnabled;
    this.isHeadersEnabled = isHeadersEnabled;
    this.isLogEnabled = isLogEnabled;
  }

  /* Technical */
  _getHeaders(reqUrl) {
    const isLogEnabled = this.isLogEnabled;

    isLogEnabled && console.group('_getHeaders');

    const headers: Record<string, any> = { Accept: undefined };

    if (this.isStandardSettingsEnabled) {
      headers.Accept = 'application/v2+json';
      headers['Content-Type'] = 'application/v2+json';
    }

    isLogEnabled &&
      this._log(
        '%c _getHeaders ',
        'background: yellow; color: #000;',
        'reqUrl',
        reqUrl,
        'headers',
        headers
      );
    isLogEnabled && console.groupEnd();

    return headers;
  }

  async _sendRequest(
    path,
    params,
    options: IOptions = { headers: {} },
    fetchDataObject
  ) {
    const headers = this.isHeadersEnabled
      ? this._getHeaders(this.basePath + path)
      : {};
    const headersAdded = Object.keys(headers).length;

    if (headersAdded) {
      options.headers = {
        ...(options.headers || {}),
        ...headers,
      };
    }

    const apiServiceResponse = await super._sendRequest(
      path,
      params,
      options,
      fetchDataObject
    );

    // this._log('apiServiceResponse', apiServiceResponse);

    return this.isStandardSettingsEnabled &&
      this.mode === Mode.Production &&
      apiServiceResponse.status
      ? {
          ...apiServiceResponse.response,
          _response: apiServiceResponse._response,
        }
      : apiServiceResponse;
  }
}
